"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.processOrderLine = void 0;
const helpers_1 = require("../../helpers");
const sendEmail_1 = require("../sendEmail");
const allGolfOrderLinesConfirmed_1 = require("./allGolfOrderLinesConfirmed");
const allOrderLinesCancelled_1 = require("./allOrderLinesCancelled");
const allOrderLinesConfirmed_1 = require("./allOrderLinesConfirmed");
const allTransferOrderLinesConfirmed_1 = require("./allTransferOrderLinesConfirmed");
const checkTransferLineComplete_1 = require("./checkTransferLineComplete");
const checkTransferLinesClientComplete_1 = require("./checkTransferLinesClientComplete");
const createInvoice_1 = require("./createInvoice");
const getGolfOrderLineChanges_1 = require("./getGolfOrderLineChanges");
const getLatestOrderLineVersion_1 = require("./getLatestOrderLineVersion");
const getLinkedOrderLines_1 = require("./getLinkedOrderLines");
const getOrderById_1 = require("./getOrderById");
const getOrderLineVersionsByStatus_1 = require("./getOrderLineVersionsByStatus");
const getOrderTotal_1 = require("./getOrderTotal");
const getPreviousOrderLineVersion_1 = require("./getPreviousOrderLineVersion");
const getPreviouslyConfirmedOrderLineVersion_1 = require("./getPreviouslyConfirmedOrderLineVersion");
const getTransferLines_1 = require("./getTransferLines");
const hasTransferOrderLines_1 = require("./hasTransferOrderLines");
const isTeeSheetAvailable_1 = require("./isTeeSheetAvailable");
const updateOrderLineVersion_1 = require("./updateOrderLineVersion");
const updateOrderStatus_1 = require("./updateOrderStatus");
const processOrderLine = async (supabase, orderLineVersion, order_line, order, context) => {
    const type = order_line.type;
    if (!order_line.versions)
        return;
    const previousOrderLineVersion = (0, getPreviousOrderLineVersion_1.getPreviousOrderLineVersion)(order_line.versions);
    const has_been_previously_confirmed = order_line.versions.some((version) => version.status === helpers_1.OrderLineStatus.CONFIRMED ||
        version.status === helpers_1.OrderLineStatus.CONFIRMED_PAID);
    // try to get the previously confirmed order line version
    context.log("versions", order_line.versions);
    const previouslyConfirmedOrderLineVersion = (0, getPreviouslyConfirmedOrderLineVersion_1.getPreviouslyConfirmedOrderLineVersion)(order_line.versions);
    context.log("previouslyConfirmedOrderLineVersion", previouslyConfirmedOrderLineVersion);
    const all_lines_cancelled = (0, allOrderLinesCancelled_1.allOrderLinesCancelled)(order);
    const all_lines_confirmed = (0, allOrderLinesConfirmed_1.allOrderLinesConfirmed)(order);
    const all_golf_confirmed = (0, allGolfOrderLinesConfirmed_1.allGolfOrderLinesConfirmed)(order);
    const all_transfer_confirmed = (0, allTransferOrderLinesConfirmed_1.allTransferOrderLinesConfirmed)(order);
    // has the status changed?
    let status_changed = true;
    if (previousOrderLineVersion) {
        if (previousOrderLineVersion.status === orderLineVersion.status)
            status_changed = false;
    }
    // is the status of the orderLineVersion.status 'WAITING_FOR_CLIENT_TRANSFER_INFO'?
    let continue_override = false;
    if (["WAITING_FOR_CLIENT_TRANSFER_INFO", "PENDING"].includes(orderLineVersion.status)) {
        continue_override = true;
    }
    // only do stuff if the status has changed
    if (!status_changed && !continue_override) {
        context.log("STATUS HAS NOT CHANGED, DO NOTHING");
        return;
    }
    if (continue_override) {
        context.log("CONTINUE OVERRIDE IS TRUE");
    }
    context.log("PROCESSING - STATUS", orderLineVersion.status);
    context.log("ORDER_LINE_ID", order_line.id);
    switch (orderLineVersion.status) {
        case helpers_1.OrderLineStatus.PENDING: {
            context.log(`### PENDING LINE (${type}) - ${order.mode} ###`);
            if (order.mode === "AUTOMATIC") {
                // CONSOLE
                if (type === "GOLF") {
                    // Need to check if the tee sheet is available for this date and time and course
                    context.log("Checking if tee sheet is available");
                    const tee_sheet_available = await (0, isTeeSheetAvailable_1.isTeeSheetAvailable)(supabase, orderLineVersion.config);
                    if (tee_sheet_available) {
                        context.log("PROCESSING GOLF - UPDATE ORDER LINE VERSION");
                        await (0, updateOrderLineVersion_1.updateOrderLineVersion)(supabase, {
                            ...orderLineVersion,
                            status: helpers_1.OrderLineStatus.WAITING_FOR_SUPPLIER,
                        });
                        // check if the golf line has previously been confirmed.  If it has we need to send the amemendment email to the supplier. otherwise we send the booking request email.
                        if (has_been_previously_confirmed) {
                            context.log("PROCESSING GOLF - PREVIOUSLY CONFIRMED ORDER LINE VERSION");
                            context.log("previouslyConfirmedOrderLineVersion", previouslyConfirmedOrderLineVersion);
                            context.log("orderLineVersion", orderLineVersion);
                            const changes = (0, getGolfOrderLineChanges_1.getGolfOrderLineChanges)(previouslyConfirmedOrderLineVersion?.config, orderLineVersion?.config);
                            context.log("CHANGES", changes);
                            const golf_email_obj = {
                                language_code: "en",
                                template_id: helpers_1.EMAIL_GOLF_LINE_AMENDMENT_REQUEST,
                                order_id: order.id,
                                order_variant_id: order_line.order_variant_id,
                                order_line_id: orderLineVersion.order_line_id,
                                data: {
                                    adjustments: changes,
                                },
                            };
                            context.log("PROCESSING GOLF ADJUSTMENTS - SENDING EMAIL", golf_email_obj);
                            await (0, sendEmail_1.sendEmail)(golf_email_obj);
                        }
                        else {
                            const golf_email_obj = {
                                language_code: "en",
                                template_id: helpers_1.EMAIL_GOLF_LINE_BOOKING_REQUEST,
                                order_id: order.id,
                                order_variant_id: order_line.order_variant_id,
                                order_line_id: orderLineVersion.order_line_id,
                            };
                            context.log("PROCESSING GOLF - SENDING EMAIL", golf_email_obj);
                            await (0, sendEmail_1.sendEmail)(golf_email_obj);
                        }
                    }
                    else {
                        context.log("PROCESSING GOLF - UPDATE ORDER LINE VERSION");
                        await (0, updateOrderLineVersion_1.updateOrderLineVersion)(supabase, {
                            ...orderLineVersion,
                            status: helpers_1.OrderLineStatus.WAITING_FOR_TEE_SHEET,
                        });
                    }
                    break;
                }
                if (type === "TRANSFER") {
                    // If the previous status was CONFIRMED and now its PENDING we need to send an emnail to the supplier informing them of the change from previous transfer line
                    if (previousOrderLineVersion?.status === helpers_1.OrderLineStatus.CONFIRMED) {
                        const cancel_transfer_email_obj = {
                            language_code: "en",
                            template_id: helpers_1.EMAIL_CANCEL_TRANSFER_LINE_CONFIRMATION,
                            order_id: order.id,
                            order_variant_id: order_line.order_variant_id,
                            order_line_id: orderLineVersion.order_line_id,
                            order_line_version_id: previousOrderLineVersion.id,
                        };
                        await (0, sendEmail_1.sendEmail)(cancel_transfer_email_obj);
                    }
                    if (all_golf_confirmed) {
                        await (0, updateOrderLineVersion_1.updateOrderLineVersion)(supabase, {
                            ...orderLineVersion,
                            status: helpers_1.OrderLineStatus.WAITING_FOR_SUPPLIER,
                        });
                        break;
                    }
                }
            }
            break;
        }
        case helpers_1.OrderLineStatus.WAITING_FOR_SUPPLIER_OVERDUE: {
            if (order.mode === "AUTOMATIC") {
                // CONSOLE
                if (type === "GOLF") {
                    // only send the email if the status has changed
                    if (status_changed) {
                        const golf_email_obj = {
                            language_code: "en",
                            template_id: helpers_1.EMAIL_GOLF_LINE_BOOKING_REQUEST_REMINDER,
                            order_id: order.id,
                            order_variant_id: order_line.order_variant_id,
                            order_line_id: orderLineVersion.order_line_id,
                        };
                        context.log("PROCESSING GOLF BOOKING REMINDER - SENDING EMAIL", golf_email_obj);
                        await (0, sendEmail_1.sendEmail)(golf_email_obj);
                    }
                }
            }
            break;
        }
        case helpers_1.OrderLineStatus.ALTERNATIVE_OFFERED: {
            if (order.mode === "AUTOMATIC") {
                if (type === "GOLF") {
                    // if an alternative is offered send the customer an email informing them of the alternative with a link to the customer portal.
                    const golf_alternative_email_obj = {
                        language_code: "en",
                        template_id: helpers_1.EMAIL_GOLF_LINE_ALTERNATIVE_OFFERED,
                        order_id: order.id,
                        order_variant_id: order_line.order_variant_id,
                        order_line_id: orderLineVersion.order_line_id,
                    };
                    await (0, sendEmail_1.sendEmail)(golf_alternative_email_obj);
                    break;
                }
            }
            break;
        }
        case helpers_1.OrderLineStatus.WAITING_FOR_CLIENT_TRANSFER_INFO: {
            if (type === "TRANSFER") {
                const config = orderLineVersion?.config;
                const transfer_lines_complete = await (0, checkTransferLineComplete_1.checkTransferLineComplete)(config);
                // if the order line is complete then make it waiting for supplier
                if (transfer_lines_complete) {
                    if (orderLineVersion) {
                        await (0, updateOrderLineVersion_1.updateOrderLineVersion)(supabase, {
                            ...orderLineVersion,
                            status: helpers_1.OrderLineStatus.WAITING_FOR_SUPPLIER,
                        });
                    }
                    const transfer_email_obj = {
                        language_code: "en",
                        template_id: helpers_1.EMAIL_TRANSFER_LINE_BOOKING_REQUEST,
                        order_id: order.id,
                        order_variant_id: order_line.order_variant_id,
                        order_line_id: orderLineVersion.order_line_id,
                    };
                    await (0, sendEmail_1.sendEmail)(transfer_email_obj);
                }
                else {
                    context.log("TODO");
                }
            }
            break;
        }
        case helpers_1.OrderLineStatus.REJECTED_BY_SUPPLIER: {
            // send an email to the customer informing them of the cancellation of this line
            if (type === "GOLF") {
                const tee_time_rejected_golf_email_obj = {
                    language_code: "en",
                    template_id: helpers_1.EMAIL_REJECT_GOLF_LINE,
                    order_id: order.id,
                    order_variant_id: order_line.order_variant_id,
                    order_line_id: orderLineVersion.order_line_id,
                };
                context.log("PROCESSING GOLF REJECTED_BY_SUPPLIER - SENDING EMAIL", tee_time_rejected_golf_email_obj);
                await (0, sendEmail_1.sendEmail)(tee_time_rejected_golf_email_obj);
                // // need to cancel all linked lines - Commended this out for now as we don't want to cancel currently
                // const linked_lines = getLinkedOrderLines(
                //   order.order_lines,
                //   orderLineVersion.order_line_id
                // );
                // for (const line of linked_lines) {
                //   if (!line.versions) continue;
                //   const latest_version = getLatestOrderLineVersion(line.versions);
                //   if (latest_version) {
                //     await updateOrderLineVersion(supabase, {
                //       ...latest_version,
                //       status: OrderLineStatus.CANCELLED,
                //     });
                //     // TO DO SEND EMAIL TO SUPPLUER INFORMING THEM OF THE CANCELLATION
                //   }
                // }
            }
            // // if all lines are cancelled then cancel the whole order.
            // if (all_lines_cancelled) {
            //   await updateOrderStatus(supabase, order, "CANCELLED");
            //   // SEND EMAIL TO CUSTOMER INFORMING THEM OF THE CANCELLATION
            //   const cancel_order_email_obj = {
            //     language_code: "en",
            //     template_id: EMAIL_WHOLE_ORDER_CANCELLED,
            //     order_id: order.id,
            //   };
            //   await sendEmail(cancel_order_email_obj);
            //   // SEND EMAIL TO SUPPORT INFORMING THEM OF THE CANCELLATION
            //   const support_email_obj = {
            //     language_code: "en",
            //     template_id: SUPPORT_EMAIL_WHOLE_ORDER_CANCELLED,
            //     order_id: order.id,
            //   };
            //   await sendEmail(support_email_obj);
            // }
            break;
        }
        // THIS IS WHEN CANCELLED BY THE CLIENT OR ADMIN ONLY.  In this instance we always want to send a cancellation request to the supplier.  THIS happens in auto and manual mode.
        case helpers_1.OrderLineStatus.CANCELLED_UNAVAILABLE:
        case helpers_1.OrderLineStatus.CANCELLED_REJECTED_BY_CLIENT:
        case helpers_1.OrderLineStatus.CANCELLED: {
            const is_waiting_for_supplier = previousOrderLineVersion &&
                [
                    helpers_1.OrderLineStatus.WAITING_FOR_SUPPLIER,
                    helpers_1.OrderLineStatus.WAITING_FOR_SUPPLIER_OVERDUE,
                ].includes(previousOrderLineVersion.status);
            const is_confirmed = previousOrderLineVersion &&
                [helpers_1.OrderLineStatus.CONFIRMED].includes(previousOrderLineVersion.status);
            if (type === "GOLF") {
                const cancel_golf_email_obj = {
                    language_code: "en",
                    template_id: is_confirmed
                        ? helpers_1.EMAIL_CANCEL_GOLF_LINE_AFTER_CONFIRMATION
                        : helpers_1.EMAIL_CANCEL_GOLF_LINE_BEFORE_CONFIRMATION,
                    order_id: order.id,
                    order_variant_id: order_line.order_variant_id,
                    order_line_id: orderLineVersion.order_line_id,
                };
                // need to cancel all linked lines
                const linked_lines = (0, getLinkedOrderLines_1.getLinkedOrderLines)(order.order_lines, orderLineVersion.order_line_id);
                if (linked_lines) {
                    context.log("HAS LINKED LINE THAT NEEDS DELETING");
                }
                // list the linked lines and cancel them
                context.log("LINKED LINES", linked_lines);
                for (const line of linked_lines) {
                    if (!line.versions)
                        continue;
                    const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(line.versions);
                    context.log("LINKED LINE LATEST VERSION", latest_version);
                    if (latest_version) {
                        context.log("CANCELLING LINKED LINE", latest_version);
                        await (0, updateOrderLineVersion_1.updateOrderLineVersion)(supabase, {
                            ...latest_version,
                            status: helpers_1.OrderLineStatus.CANCELLED,
                        });
                        // TO DO SEND EMAIL TO SUPPLUER INFORMING THEM OF THE CANCELLATION
                    }
                }
                if (is_waiting_for_supplier || is_confirmed) {
                    await (0, sendEmail_1.sendEmail)(cancel_golf_email_obj);
                }
                if (order.mode === "AUTOMATIC") {
                    // if a line has been cancelled check if all other golf lines are confirmed and if necessary process the transfer lines
                    if (all_golf_confirmed && !all_transfer_confirmed) {
                        // if all golf_confirmed then we need to check if there are any transfer lines and send those for supplier confirmation
                        const transfersProcessed = await processTransferLinesAfterGolfConfirmation(supabase, order.id, context);
                        if (!transfersProcessed) {
                            context.log("NO TRANSFER LINES FOUND - SEND PAYMENT REQUEST");
                        }
                    }
                }
            }
            if (type === "TRANSFER") {
                const cancel_transfer_email_obj = {
                    language_code: "en",
                    template_id: helpers_1.EMAIL_CANCEL_TRANSFER_LINE_CONFIRMATION,
                    order_id: order.id,
                    order_variant_id: order_line.order_variant_id,
                    order_line_id: orderLineVersion.order_line_id,
                };
                if (is_waiting_for_supplier || is_confirmed)
                    await (0, sendEmail_1.sendEmail)(cancel_transfer_email_obj);
            }
            // get the updated order and check if all lines are cancelled
            const updatedOrder = await (0, getOrderById_1.getOrderById)(supabase, order.id);
            // if all lines are cancelled then cancel the whole order.
            if (all_lines_cancelled) {
                await (0, updateOrderStatus_1.updateOrderStatus)(supabase, updatedOrder, "CANCELLED");
                // SEND EMAIL TO CUSTOMER INFORMING THEM OF THE CANCELLATION
                const cancel_order_email_obj = {
                    language_code: "en",
                    template_id: helpers_1.EMAIL_WHOLE_ORDER_CANCELLED,
                    order_id: order.id,
                };
                await (0, sendEmail_1.sendEmail)(cancel_order_email_obj);
                // SEND EMAIL TO SUPPORT INFORMING THEM OF THE CANCELLATION
                const support_email_obj = {
                    language_code: "en",
                    template_id: helpers_1.SUPPORT_EMAIL_WHOLE_ORDER_CANCELLED,
                    order_id: order.id,
                };
                await (0, sendEmail_1.sendEmail)(support_email_obj);
                //   // need to reverse ALL invoices that have not been paid.
            }
            break;
        }
        case helpers_1.OrderLineStatus.CONFIRMED: {
            if (order.mode === "AUTOMATIC") {
                // have all lines been confirmed?
                // if all lines confirmed then we need to request payment from the customer
                context.log("all_lines_confirmed", all_lines_confirmed);
                if (all_lines_confirmed) {
                    context.log("ALL LINES CONFIRMED - update order status - WAITING_FOR_PAYMENT");
                    await (0, updateOrderStatus_1.updateOrderStatus)(supabase, order, "WAITING_FOR_PAYMENT");
                    // send email to the customer requesting payment
                    const payment_request_email_obj = {
                        language_code: "en",
                        template_id: helpers_1.EMAIL_STANDARD_PAYMENT_REQUEST,
                        order_id: order.id,
                    };
                    context.log("PROCESSING GOLF - SENDING PAYMENT REQUEST EMAIL", payment_request_email_obj);
                    await (0, sendEmail_1.sendEmail)(payment_request_email_obj);
                    // create an invoice for the order
                    context.log("Creating invoice for order", order.id);
                    context.log("order total", (0, getOrderTotal_1.getOrderTotal)(order));
                    await (0, createInvoice_1.createInvoice)(supabase, order.id, `Full payment for ${order.reference}`, (0, getOrderTotal_1.getOrderTotal)(order), false, helpers_1.ADMIN_USER_ID);
                }
                else {
                    if (type === "GOLF") {
                        // if a golf line is confirmed we need to check if all golf lines are confirmed
                        if (all_golf_confirmed && !all_transfer_confirmed) {
                            // if all golf_confirmed then we need to check if there are any transfer lines and send those for supplier confirmation
                            const transfersProcessed = await processTransferLinesAfterGolfConfirmation(supabase, order.id, context);
                            if (!transfersProcessed) {
                                context.log("NO TRANSFER LINES FOUND - SEND PAYMENT REQUEST");
                            }
                        }
                        // if not all golf is confirmed then wait....
                    }
                    //   if (type === "TRANSFER") {
                    //   }
                }
            }
            break;
        }
        case helpers_1.OrderLineStatus.CONFIRMED_PAID: {
            // IF Confirmed & PAID send the Purchase Order email to the supplier.
            const total_versions = (0, getOrderLineVersionsByStatus_1.getOrderLineVersionsByStatus)(order_line.versions, helpers_1.OrderLineStatus.CONFIRMED_PAID);
            let is_revision = false;
            if (total_versions && total_versions.length > 1) {
                is_revision = true;
            }
            if (type === "GOLF") {
                const purchase_order_email_obj = {
                    language_code: "en",
                    template_id: is_revision
                        ? helpers_1.REVISED_GOLF_PURCHASE_ORDER_SUPPLIER
                        : helpers_1.GOLF_PURCHASE_ORDER_SUPPLIER,
                    order_id: order.id,
                    order_variant_id: order_line.order_variant_id,
                    order_line_id: orderLineVersion.order_line_id,
                };
                await (0, sendEmail_1.sendEmail)(purchase_order_email_obj);
            }
            if (type === "TRANSFER") {
                const purchase_order_email_obj = {
                    language_code: "en",
                    template_id: is_revision
                        ? helpers_1.REVISED_TRANSFER_PURCHASE_ORDER_SUPPLIER
                        : helpers_1.TRANSFER_PURCHASE_ORDER_SUPPLIER,
                    order_id: order.id,
                    order_variant_id: order_line.order_variant_id,
                    order_line_id: orderLineVersion.order_line_id,
                };
                await (0, sendEmail_1.sendEmail)(purchase_order_email_obj);
            }
            break;
        }
    }
};
exports.processOrderLine = processOrderLine;
// Function to process transfer lines after golf confirmation
const processTransferLinesAfterGolfConfirmation = async (supabase, order_id, context) => {
    // get the fresh order object
    const order = await (0, getOrderById_1.getOrderById)(supabase, order_id);
    if ((0, hasTransferOrderLines_1.hasTransferOrderLines)(order)) {
        const transferLines = (0, getTransferLines_1.getTransferLines)(order);
        context.log("TRANSFER LINES", transferLines);
        // CHECK IF THE TRANSFER LINES HAVE THEIR CLIENT REQUIRED DATA SET.
        const transferLinesClientComplete = await (0, checkTransferLinesClientComplete_1.checkTransferLinesClientComplete)(supabase, transferLines);
        await (0, updateOrderStatus_1.updateOrderStatus)(supabase, order, "CONFIRMING_ALL");
        if (!transferLinesClientComplete) {
            // if transfer lines are not complete then we need to send an email to the customer informing them that we need more information.
            const transfer_lines_not_complete_email_obj = {
                language_code: "en",
                template_id: helpers_1.EMAIL_CLIENT_TRANSFER_DETAILS_REQUEST,
                order_id: order.id,
            };
            await (0, sendEmail_1.sendEmail)(transfer_lines_not_complete_email_obj);
            return false; // Indicate that the process stopped due to incomplete transfer lines
        }
        else {
            // Transfer lines are COMPLETE - Update status and send email to supplier
            try {
                for (const line of transferLines) {
                    if (!line.versions)
                        continue;
                    const orderTransferLineVersion = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(line.versions);
                    if (orderTransferLineVersion) {
                        await (0, updateOrderLineVersion_1.updateOrderLineVersion)(supabase, {
                            ...orderTransferLineVersion,
                            status: helpers_1.OrderLineStatus.WAITING_FOR_SUPPLIER,
                        });
                    }
                    const transfer_email_obj = {
                        language_code: "en",
                        template_id: helpers_1.EMAIL_TRANSFER_LINE_BOOKING_REQUEST,
                        order_id: order.id,
                        order_variant_id: line.order_variant_id,
                        order_line_id: line.id,
                    };
                    await (0, sendEmail_1.sendEmail)(transfer_email_obj);
                }
                return true; // Indicate successful processing
            }
            catch (error) {
                context.log("ERROR UPDATING ORDER STATUS", error);
                return false; // Indicate error during processing
            }
        }
    }
    else {
        context.log("NO TRANSFER LINES FOUND - SEND PAYMENT REQUEST");
        return true; // No transfer lines to process, so the flow can continue
    }
};
